// import React, { useState } from 'react'
// import { Box, Typography, Button, Stack, TextField } from '@mui/material'
// import { motion } from 'framer-motion'
// import { useTranslation } from 'react-i18next'
// import SendIcon from '@mui/icons-material/Send'
// import { Navebarehero } from '../Components/Navebarehero'
// import { contactUsData } from '../Data/contactUsData'

// const fadeUp = {
//   hidden: { opacity: 0, y: 24 },
//   visible: (delay = 0) => ({
//     opacity: 1,
//     y: 0,
//     transition: { duration: 0.6, ease: 'easeOut', delay },
//   }),
// }

// // هيرو صفحة الكونتاكت - نفس هيكل هيرو صفحة الأباوت بالظبط
// const ContactHero = ({ isArabic, data }) => {
//   const lang = isArabic ? 'ar' : 'en'

//   return (
//     <Box sx={{ position: 'relative', width: '100%', height: { xs: '65vh', md: '75vh' }, bgcolor: '#2B2B2B', overflow: 'hidden' }}>
//       <Box
//         component={motion.img}
//         src={data.image}
//         alt=""
//         initial={{ scale: 1.1 }}
//         animate={{ scale: 1 }}
//         transition={{ duration: 1.8, ease: 'easeOut' }}
//         sx={{
//           position: 'absolute',
//           inset: 0,
//           width: '100%',
//           height: '100%',
//           objectFit: 'cover',
//           filter: 'grayscale(0.3) brightness(0.55)',
//           zIndex: 0,
//         }}
//       />
//       <Box
//         sx={{
//           position: 'absolute',
//           inset: 0,
//           zIndex: 1,
//           background: 'linear-gradient(180deg, rgba(43,43,43,0.55) 0%, rgba(122,46,58,0.18) 50%, rgba(43,43,43,0.8) 100%)',
//         }}
//       />

//       <Box
//         component={motion.div}
//         initial={{ opacity: 0, y: 24 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.8, delay: 0.2, ease: 'easeOut' }}
//         sx={{
//           position: 'absolute',
//           inset: 0,
//           zIndex: 2,
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//           justifyContent: 'center',
//           textAlign: 'center',
//           gap: 1.5,
//           px: 2,
//         }}
//       >
//         <Typography
//           sx={{
//             fontFamily: isArabic ? "'IBM Plex Sans Arabic', sans-serif" : "'Manrope', sans-serif",
//             color: '#D9A5A5',
//             fontWeight: 700,
//             letterSpacing: 2,
//             fontSize: '0.85rem',
//             textTransform: 'uppercase',
//           }}
//         >
//           {data.eyebrow[lang]}
//         </Typography>
//         <Typography
//           variant="h1"
//           sx={{
//             fontFamily: isArabic ? "'El Messiri', serif" : "'Bodoni Moda', serif",
//             fontWeight: isArabic ? 700 : 600,
//             fontSize: { xs: '2.3rem', md: '3.8rem' },
//             color: '#fff',
//           }}
//         >
//           {data.title[lang]}
//         </Typography>
//         <Typography sx={{ color: 'rgba(217,214,207,0.85)', maxWidth: 560 }}>
//           {data.subtitle[lang]}
//         </Typography>
//       </Box>
//     </Box>
//   )
// }

// export const ContactUsPage = () => {
//   const { i18n } = useTranslation()
//   const isArabic = (i18n.language || 'ar').startsWith('ar')
//   const lang = isArabic ? 'ar' : 'en'

//   const headingFont = isArabic ? "'El Messiri', serif" : "'Bodoni Moda', serif"
//   const bodyFont = isArabic ? "'IBM Plex Sans Arabic', sans-serif" : "'Manrope', sans-serif"

//   const { hero, quickInfo, formSection, processSection } = contactUsData

//   const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' })
//   const [submitted, setSubmitted] = useState(false)

//   const handleChange = (field) => (e) => {
//     setForm((prev) => ({ ...prev, [field]: e.target.value }))
//   }

//   const handleSubmit = (e) => {
//     e.preventDefault()
//     console.log('Contact page form submitted:', form)
//     setSubmitted(true)
//     setForm({ name: '', email: '', phone: '', message: '' })
//     setTimeout(() => setSubmitted(false), 4000)
//   }

//   const inputStyles = {
//     '& .MuiOutlinedInput-root': {
//       fontFamily: bodyFont,
//       color: '#D9D6CF',
//       bgcolor: 'rgba(217,214,207,0.05)',
//       borderRadius: '10px',
//       '& fieldset': { borderColor: 'rgba(217,214,207,0.15)' },
//       '&:hover fieldset': { borderColor: 'rgba(217,214,207,0.3)' },
//       '&.Mui-focused fieldset': { borderColor: '#7A2E3A' },
//     },
//     '& .MuiInputLabel-root': { fontFamily: bodyFont, color: 'rgba(217,214,207,0.55)' },
//     '& .MuiInputLabel-root.Mui-focused': { color: '#D9A5A5' },
//     '& .MuiInputBase-input': { fontFamily: bodyFont },
//   }

//   return (
//     <Box sx={{ bgcolor: '#2B2B2B', minHeight: '100vh' }}>
//       <Navebarehero />

//       <ContactHero isArabic={isArabic} data={hero} />

//       {/* شريط بيانات التواصل السريعة */}
//       <Box sx={{ bgcolor: '#242424', py: { xs: 8, md: 10 } }}>
//         <Box
//           sx={{
//             maxWidth: 1300,
//             mx: 'auto',
//             px: { xs: 3, md: 6 },
//             display: 'grid',
//             gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' },
//             gap: { xs: 4, md: 3 },
//           }}
//         >
//           {quickInfo.map((item, index) => {
//             const Icon = item.icon
//             const content = (
//               <>
//                 <Box
//                   sx={{
//                     width: 46,
//                     height: 46,
//                     borderRadius: '14px',
//                     bgcolor: 'rgba(122,46,58,0.15)',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     mx: 'auto',
//                     mb: 1.5,
//                   }}
//                 >
//                   <Icon sx={{ color: '#7A2E3A', fontSize: 22 }} />
//                 </Box>
//                 <Typography
//                   sx={{
//                     fontFamily: headingFont,
//                     fontWeight: 600,
//                     fontSize: { xs: '0.95rem', md: '1.05rem' },
//                     color: '#D9D6CF',
//                     lineHeight: 1.3,
//                   }}
//                 >
//                   {item.value[lang]}
//                 </Typography>
//                 <Typography sx={{ fontFamily: bodyFont, color: 'rgba(217,214,207,0.6)', fontSize: '0.8rem', mt: 0.5 }}>
//                   {item.label[lang]}
//                 </Typography>
//               </>
//             )

//             return (
//               <Box
//                 key={item.label.en}
//                 component={motion.div}
//                 initial={{ opacity: 0, y: 20 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true, amount: 0.5 }}
//                 transition={{ duration: 0.5, delay: index * 0.1 }}
//                 sx={{ textAlign: 'center' }}
//               >
//                 {item.href ? (
//                   <Box component="a" href={item.href} sx={{ textDecoration: 'none', display: 'block' }}>
//                     {content}
//                   </Box>
//                 ) : (
//                   content
//                 )}
//               </Box>
//             )
//           })}
//         </Box>
//       </Box>

//       {/* سيكشن الفورم - نص وصورة زي سيكشن قصتنا في صفحة الأباوت */}
//       <Box sx={{ bgcolor: '#2B2B2B', py: { xs: 10, md: 14 } }}>
//         <Box
//           sx={{
//             maxWidth: 1300,
//             mx: 'auto',
//             px: { xs: 3, md: 6 },
//             display: 'grid',
//             gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
//             gap: { xs: 5, md: 8 },
//             alignItems: 'center',
//           }}
//         >
//           <Box
//             component={motion.form}
//             onSubmit={handleSubmit}
//             initial={{ opacity: 0, x: isArabic ? 40 : -40 }}
//             whileInView={{ opacity: 1, x: 0 }}
//             viewport={{ once: true, amount: 0.3 }}
//             transition={{ duration: 0.7, ease: 'easeOut' }}
//             sx={{ order: { xs: 1, md: isArabic ? 2 : 1 } }}
//           >
//             <Typography
//               sx={{
//                 fontFamily: bodyFont,
//                 color: '#7A2E3A',
//                 fontWeight: 700,
//                 letterSpacing: 2,
//                 fontSize: '0.85rem',
//                 textTransform: 'uppercase',
//                 mb: 1.5,
//               }}
//             >
//               {formSection.eyebrow[lang]}
//             </Typography>
//             <Typography
//               sx={{
//                 fontFamily: headingFont,
//                 fontWeight: isArabic ? 700 : 500,
//                 fontSize: { xs: '2rem', md: '2.6rem' },
//                 color: '#D9D6CF',
//                 mb: 3,
//                 lineHeight: 1.2,
//               }}
//             >
//               {formSection.title[lang]}
//             </Typography>
//             <Typography
//               sx={{
//                 fontFamily: bodyFont,
//                 color: 'rgba(217,214,207,0.75)',
//                 fontSize: '1rem',
//                 lineHeight: 2,
//                 mb: 4,
//               }}
//             >
//               {formSection.description[lang]}
//             </Typography>

//             <Stack spacing={2.5}>
//               <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2.5}>
//                 <TextField
//                   fullWidth
//                   label={isArabic ? 'الاسم بالكامل' : 'Full Name'}
//                   value={form.name}
//                   onChange={handleChange('name')}
//                   required
//                   sx={inputStyles}
//                 />
//                 <TextField
//                   fullWidth
//                   type="tel"
//                   label={isArabic ? 'رقم الهاتف' : 'Phone Number'}
//                   value={form.phone}
//                   onChange={handleChange('phone')}
//                   required
//                   sx={inputStyles}
//                 />
//               </Stack>
//               <TextField
//                 fullWidth
//                 type="email"
//                 label={isArabic ? 'البريد الإلكتروني' : 'Email Address'}
//                 value={form.email}
//                 onChange={handleChange('email')}
//                 required
//                 sx={inputStyles}
//               />
//               <TextField
//                 fullWidth
//                 multiline
//                 rows={4}
//                 label={isArabic ? 'رسالتك' : 'Your Message'}
//                 value={form.message}
//                 onChange={handleChange('message')}
//                 required
//                 sx={inputStyles}
//               />

//               <Button
//                 type="submit"
//                 endIcon={<SendIcon sx={{ transform: isArabic ? 'scaleX(-1)' : 'none' }} />}
//                 variant="contained"
//                 sx={{
//                   mt: 1,
//                   alignSelf: 'flex-start',
//                   bgcolor: '#7A2E3A',
//                   color: '#D9D6CF',
//                   px: 4,
//                   py: 1.4,
//                   borderRadius: '999px',
//                   fontFamily: bodyFont,
//                   fontWeight: 600,
//                   '&:hover': { bgcolor: '#8f3646' },
//                 }}
//               >
//                 {submitted
//                   ? (isArabic ? 'تم الإرسال بنجاح!' : 'Sent Successfully!')
//                   : (isArabic ? 'إرسال الرسالة' : 'Send Message')}
//               </Button>
//             </Stack>
//           </Box>

//           <Box
//             component={motion.div}
//             initial={{ opacity: 0, scale: 0.95 }}
//             whileInView={{ opacity: 1, scale: 1 }}
//             viewport={{ once: true, amount: 0.3 }}
//             transition={{ duration: 0.7, ease: 'easeOut' }}
//             sx={{
//               order: { xs: 2, md: isArabic ? 1 : 2 },
//               borderRadius: '24px',
//               overflow: 'hidden',
//               boxShadow: '0 25px 50px rgba(0,0,0,0.4)',
//               aspectRatio: '4 / 3',
//             }}
//           >
//             <Box
//               component="img"
//               src={formSection.image}
//               alt={formSection.title[lang]}
//               sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
//             />
//           </Box>
//         </Box>
//       </Box>

//       {/* سيكشن خطوات التواصل - بنفس شكل شبكة القيم في صفحة الأباوت */}
//       <Box sx={{ bgcolor: '#242424', py: { xs: 10, md: 14 } }}>
//         <Box sx={{ maxWidth: 1300, mx: 'auto', px: { xs: 3, md: 6 } }}>
//           <Box
//             component={motion.div}
//             initial="hidden"
//             whileInView="visible"
//             viewport={{ once: true, amount: 0.5 }}
//             sx={{ textAlign: 'center', mb: { xs: 6, md: 8 } }}
//           >
//             <Typography
//               component={motion.p}
//               custom={0}
//               variants={fadeUp}
//               sx={{
//                 fontFamily: bodyFont,
//                 color: '#7A2E3A',
//                 fontWeight: 700,
//                 letterSpacing: 2,
//                 fontSize: '0.85rem',
//                 textTransform: 'uppercase',
//                 mb: 1.5,
//               }}
//             >
//               {processSection.eyebrow[lang]}
//             </Typography>
//             <Typography
//               component={motion.h2}
//               custom={0.1}
//               variants={fadeUp}
//               sx={{
//                 fontFamily: headingFont,
//                 fontWeight: isArabic ? 700 : 500,
//                 fontSize: { xs: '2.2rem', md: '3rem' },
//                 color: '#D9D6CF',
//               }}
//             >
//               {processSection.title[lang]}
//             </Typography>
//           </Box>

//           <Box
//             sx={{
//               display: 'grid',
//               gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' },
//               gap: 3,
//             }}
//           >
//             {processSection.items.map((step, index) => {
//               const Icon = step.icon
//               return (
//                 <Box
//                   key={step.title.en}
//                   component={motion.div}
//                   initial={{ opacity: 0, y: 24 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   viewport={{ once: true, amount: 0.3 }}
//                   transition={{ duration: 0.5, delay: index * 0.1 }}
//                   sx={{
//                     position: 'relative',
//                     borderRadius: '18px',
//                     border: '1px solid rgba(217,214,207,0.12)',
//                     bgcolor: 'rgba(217,214,207,0.03)',
//                     p: 3.5,
//                     transition: 'border-color 0.3s ease',
//                     '&:hover': { borderColor: 'rgba(122,46,58,0.5)' },
//                   }}
//                 >
//                   <Typography
//                     sx={{
//                       position: 'absolute',
//                       top: 14,
//                       insetInlineEnd: 18,
//                       fontFamily: headingFont,
//                       fontWeight: 700,
//                       fontSize: '1.4rem',
//                       color: 'rgba(217,214,207,0.12)',
//                     }}
//                   >
//                     {String(index + 1).padStart(2, '0')}
//                   </Typography>
//                   <Box
//                     sx={{
//                       width: 52,
//                       height: 52,
//                       borderRadius: '14px',
//                       bgcolor: 'rgba(122,46,58,0.15)',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       mb: 2.5,
//                     }}
//                   >
//                     <Icon sx={{ color: '#7A2E3A', fontSize: 26 }} />
//                   </Box>
//                   <Typography
//                     sx={{
//                       fontFamily: headingFont,
//                       fontWeight: 600,
//                       fontSize: '1.1rem',
//                       color: '#D9D6CF',
//                       mb: 1.2,
//                     }}
//                   >
//                     {step.title[lang]}
//                   </Typography>
//                   <Typography sx={{ fontFamily: bodyFont, color: 'rgba(217,214,207,0.65)', fontSize: '0.9rem', lineHeight: 1.8 }}>
//                     {step.desc[lang]}
//                   </Typography>
//                 </Box>
//               )
//             })}
//           </Box>
//         </Box>
//       </Box>

//     </Box>
//   )
// }

// after send to gmail + save lead to backend
import React, { useState } from 'react'
import { Box, Typography, Button, Stack, TextField, Alert } from '@mui/material'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import SendIcon from '@mui/icons-material/Send'
import emailjs from '@emailjs/browser'
import axios from 'axios'
import { Navebarehero } from '../Components/Navebarehero'
import { contactUsData } from '../Data/contactUsData'

// 🔑 بيانات EmailJS - عدّل القيم دي ببيانات حسابك بعد إنشائه على emailjs.com
// 🔑 بيانات EmailJS - عدّل القيم دي ببيانات حسابك بعد إنشائه على emailjs.com
const EMAILJS_SERVICE_ID = 'service_asaf6vt'
const EMAILJS_TEMPLATE_ID = 'template_zqyutor'
const EMAILJS_PUBLIC_KEY = '5GSKB0HmL516-WxJY'

// 🔗 نفس الراوت المستخدم في صفحة الداشبورد لعرض الـ Leads
const LEADS_URL = 'https://lyorauraproperties-api.onrender.com/api/v1/Leads'

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: (delay = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: 'easeOut', delay },
  }),
}

// هيرو صفحة الكونتاكت - نفس هيكل هيرو صفحة الأباوت بالظبط
const ContactHero = ({ isArabic, data }) => {
  const lang = isArabic ? 'ar' : 'en'

  return (
    <Box sx={{ position: 'relative', width: '100%', height: { xs: '65vh', md: '75vh' }, bgcolor: '#2B2B2B', overflow: 'hidden' }}>
      <Box
        component={motion.img}
        src={data.image}
        alt=""
        initial={{ scale: 1.1 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.8, ease: 'easeOut' }}
        sx={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          filter: 'grayscale(0.3) brightness(0.55)',
          zIndex: 0,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          zIndex: 1,
          background: 'linear-gradient(180deg, rgba(43,43,43,0.55) 0%, rgba(122,46,58,0.18) 50%, rgba(43,43,43,0.8) 100%)',
        }}
      />

      <Box
        component={motion.div}
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2, ease: 'easeOut' }}
        sx={{
          position: 'absolute',
          inset: 0,
          zIndex: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          gap: 1.5,
          px: 2,
        }}
      >
        <Typography
          sx={{
            fontFamily: isArabic ? "'IBM Plex Sans Arabic', sans-serif" : "'Manrope', sans-serif",
            color: '#D9A5A5',
            fontWeight: 700,
            letterSpacing: 2,
            fontSize: '0.85rem',
            textTransform: 'uppercase',
          }}
        >
          {data.eyebrow[lang]}
        </Typography>
        <Typography
          variant="h1"
          sx={{
            fontFamily: isArabic ? "'El Messiri', serif" : "'Bodoni Moda', serif",
            fontWeight: isArabic ? 700 : 600,
            fontSize: { xs: '2.3rem', md: '3.8rem' },
            color: '#fff',
          }}
        >
          {data.title[lang]}
        </Typography>
        <Typography sx={{ color: 'rgba(217,214,207,0.85)', maxWidth: 560 }}>
          {data.subtitle[lang]}
        </Typography>
      </Box>
    </Box>
  )
}

export const ContactUsPage = () => {
  const { i18n } = useTranslation()
  const isArabic = (i18n.language || 'ar').startsWith('ar')
  const lang = isArabic ? 'ar' : 'en'

  const headingFont = isArabic ? "'El Messiri', serif" : "'Bodoni Moda', serif"
  const bodyFont = isArabic ? "'IBM Plex Sans Arabic', sans-serif" : "'Manrope', sans-serif"

  const { hero, quickInfo, formSection, processSection } = contactUsData

  const [form, setForm] = useState({ name: '', email: '', phone: '', countryCode: '+971', message: '' })
  const [status, setStatus] = useState('idle') // idle | sending | success | error

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setStatus('sending')

    try {
      // 1) نسجل الليد في الداتابيز الأول (الجزء الأساسي)
      await axios.post(LEADS_URL, {
        name: form.name,
        email: form.email,
        phone: form.phone,
        country_code: form.countryCode,
        message: form.message,
        registerPlace: 'Contact Page',
      })

      // 2) بعد ما يتسجل بنجاح، نبعت إيميل تنبيه - لو فشل الإيميل مش هيوقف العملية
      try {
        await emailjs.send(
          EMAILJS_SERVICE_ID,
          EMAILJS_TEMPLATE_ID,
          {
            title: isArabic ? 'رسالة جديدة من الموقع' : 'New message from the website',
            name: form.name,
            time: new Date().toLocaleString(isArabic ? 'ar-AE' : 'en-AE'),
            message: form.message,
            phone: `${form.countryCode} ${form.phone}`,
            email: form.email,
          },
          EMAILJS_PUBLIC_KEY,
        )
      } catch (emailErr) {
        console.error('Email notification failed (lead was still saved):', emailErr)
      }

      setStatus('success')
      setForm({ name: '', email: '', phone: '', countryCode: '+971', message: '' })
      setTimeout(() => setStatus('idle'), 5000)
    } catch (err) {
      console.error('Contact form lead submission error:', err)
      setStatus('error')
      setTimeout(() => setStatus('idle'), 5000)
    }
  }

  const inputStyles = {
    '& .MuiOutlinedInput-root': {
      fontFamily: bodyFont,
      color: '#D9D6CF',
      bgcolor: 'rgba(217,214,207,0.05)',
      borderRadius: '10px',
      '& fieldset': { borderColor: 'rgba(217,214,207,0.15)' },
      '&:hover fieldset': { borderColor: 'rgba(217,214,207,0.3)' },
      '&.Mui-focused fieldset': { borderColor: '#7A2E3A' },
    },
    '& .MuiInputLabel-root': { fontFamily: bodyFont, color: 'rgba(217,214,207,0.55)' },
    '& .MuiInputLabel-root.Mui-focused': { color: '#D9A5A5' },
    '& .MuiInputBase-input': { fontFamily: bodyFont },
  }

  return (
    <Box sx={{ bgcolor: '#2B2B2B', minHeight: '100vh' }}>
      <Navebarehero />

      <ContactHero isArabic={isArabic} data={hero} />

      {/* شريط بيانات التواصل السريعة */}
      <Box sx={{ bgcolor: '#242424', py: { xs: 8, md: 10 } }}>
        <Box
          sx={{
            maxWidth: 1300,
            mx: 'auto',
            px: { xs: 3, md: 6 },
            display: 'grid',
            gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' },
            gap: { xs: 4, md: 3 },
          }}
        >
          {quickInfo.map((item, index) => {
            const Icon = item.icon
            const content = (
              <>
                <Box
                  sx={{
                    width: 46,
                    height: 46,
                    borderRadius: '14px',
                    bgcolor: 'rgba(122,46,58,0.15)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mx: 'auto',
                    mb: 1.5,
                  }}
                >
                  <Icon sx={{ color: '#7A2E3A', fontSize: 22 }} />
                </Box>
                <Typography
                  sx={{
                    fontFamily: headingFont,
                    fontWeight: 600,
                    fontSize: { xs: '0.95rem', md: '1.05rem' },
                    color: '#D9D6CF',
                    lineHeight: 1.3,
                  }}
                >
                  {item.value[lang]}
                </Typography>
                <Typography sx={{ fontFamily: bodyFont, color: 'rgba(217,214,207,0.6)', fontSize: '0.8rem', mt: 0.5 }}>
                  {item.label[lang]}
                </Typography>
              </>
            )

            return (
              <Box
                key={item.label.en}
                component={motion.div}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.5 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                sx={{ textAlign: 'center' }}
              >
                {item.href ? (
                  <Box component="a" href={item.href} sx={{ textDecoration: 'none', display: 'block' }}>
                    {content}
                  </Box>
                ) : (
                  content
                )}
              </Box>
            )
          })}
        </Box>
      </Box>

      {/* سيكشن الفورم - نص وصورة زي سيكشن قصتنا في صفحة الأباوت */}
      <Box sx={{ bgcolor: '#2B2B2B', py: { xs: 10, md: 14 } }}>
        <Box
          sx={{
            maxWidth: 1300,
            mx: 'auto',
            px: { xs: 3, md: 6 },
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
            gap: { xs: 5, md: 8 },
            alignItems: 'center',
          }}
        >
          <Box
            component={motion.form}
            onSubmit={handleSubmit}
            initial={{ opacity: 0, x: isArabic ? 40 : -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7, ease: 'easeOut' }}
            sx={{ order: { xs: 1, md: isArabic ? 2 : 1 } }}
          >
            <Typography
              sx={{
                fontFamily: bodyFont,
                color: '#7A2E3A',
                fontWeight: 700,
                letterSpacing: 2,
                fontSize: '0.85rem',
                textTransform: 'uppercase',
                mb: 1.5,
              }}
            >
              {formSection.eyebrow[lang]}
            </Typography>
            <Typography
              sx={{
                fontFamily: headingFont,
                fontWeight: isArabic ? 700 : 500,
                fontSize: { xs: '2rem', md: '2.6rem' },
                color: '#D9D6CF',
                mb: 3,
                lineHeight: 1.2,
              }}
            >
              {formSection.title[lang]}
            </Typography>
            <Typography
              sx={{
                fontFamily: bodyFont,
                color: 'rgba(217,214,207,0.75)',
                fontSize: '1rem',
                lineHeight: 2,
                mb: 4,
              }}
            >
              {formSection.description[lang]}
            </Typography>

            <Stack spacing={2.5}>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2.5}>
                <TextField
                  fullWidth
                  label={isArabic ? 'الاسم بالكامل' : 'Full Name'}
                  value={form.name}
                  onChange={handleChange('name')}
                  required
                  sx={inputStyles}
                />
                <TextField
                  fullWidth
                  type="email"
                  label={isArabic ? 'البريد الإلكتروني' : 'Email Address'}
                  value={form.email}
                  onChange={handleChange('email')}
                  required
                  sx={inputStyles}
                />
              </Stack>

              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2.5}>
                <TextField
                  label={isArabic ? 'كود الدولة' : 'Country Code'}
                  value={form.countryCode}
                  onChange={handleChange('countryCode')}
                  placeholder="+971"
                  required
                  sx={{ width: { xs: '100%', sm: 140 }, ...inputStyles }}
                />
                <TextField
                  fullWidth
                  type="tel"
                  label={isArabic ? 'رقم الهاتف' : 'Phone Number'}
                  value={form.phone}
                  onChange={handleChange('phone')}
                  required
                  sx={inputStyles}
                />
              </Stack>

              <TextField
                fullWidth
                multiline
                rows={4}
                label={isArabic ? 'رسالتك' : 'Your Message'}
                value={form.message}
                onChange={handleChange('message')}
                required
                sx={inputStyles}
              />

              {status === 'success' && (
                <Alert severity="success" sx={{ fontFamily: bodyFont }}>
                  {isArabic ? 'تم إرسال بياناتك بنجاح، هنتواصل معاك قريبًا.' : 'Your details were sent successfully, we will contact you soon.'}
                </Alert>
              )}
              {status === 'error' && (
                <Alert severity="error" sx={{ fontFamily: bodyFont }}>
                  {isArabic ? 'حصل خطأ أثناء الإرسال، حاول مرة أخرى.' : 'Something went wrong while sending. Please try again.'}
                </Alert>
              )}

              <Button
                type="submit"
                disabled={status === 'sending'}
                endIcon={<SendIcon sx={{ transform: isArabic ? 'scaleX(-1)' : 'none' }} />}
                variant="contained"
                sx={{
                  mt: 1,
                  alignSelf: 'flex-start',
                  bgcolor: '#7A2E3A',
                  color: '#D9D6CF',
                  px: 4,
                  py: 1.4,
                  borderRadius: '999px',
                  fontFamily: bodyFont,
                  fontWeight: 600,
                  '&:hover': { bgcolor: '#8f3646' },
                  '&.Mui-disabled': { bgcolor: 'rgba(122,46,58,0.5)', color: 'rgba(217,214,207,0.6)' },
                }}
              >
                {status === 'sending'
                  ? (isArabic ? 'جاري الإرسال...' : 'Sending...')
                  : (isArabic ? 'إرسال الرسالة' : 'Send Message')}
              </Button>
            </Stack>
          </Box>

          <Box
            component={motion.div}
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7, ease: 'easeOut' }}
            sx={{
              order: { xs: 2, md: isArabic ? 1 : 2 },
              borderRadius: '24px',
              overflow: 'hidden',
              boxShadow: '0 25px 50px rgba(0,0,0,0.4)',
              aspectRatio: '4 / 3',
            }}
          >
            <Box
              component="img"
              src={formSection.image}
              alt={formSection.title[lang]}
              sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
            />
          </Box>
        </Box>
      </Box>

      {/* سيكشن خطوات التواصل - بنفس شكل شبكة القيم في صفحة الأباوت */}
      <Box sx={{ bgcolor: '#242424', py: { xs: 10, md: 14 } }}>
        <Box sx={{ maxWidth: 1300, mx: 'auto', px: { xs: 3, md: 6 } }}>
          <Box
            component={motion.div}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
            sx={{ textAlign: 'center', mb: { xs: 6, md: 8 } }}
          >
            <Typography
              component={motion.p}
              custom={0}
              variants={fadeUp}
              sx={{
                fontFamily: bodyFont,
                color: '#7A2E3A',
                fontWeight: 700,
                letterSpacing: 2,
                fontSize: '0.85rem',
                textTransform: 'uppercase',
                mb: 1.5,
              }}
            >
              {processSection.eyebrow[lang]}
            </Typography>
            <Typography
              component={motion.h2}
              custom={0.1}
              variants={fadeUp}
              sx={{
                fontFamily: headingFont,
                fontWeight: isArabic ? 700 : 500,
                fontSize: { xs: '2.2rem', md: '3rem' },
                color: '#D9D6CF',
              }}
            >
              {processSection.title[lang]}
            </Typography>
          </Box>

          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' },
              gap: 3,
            }}
          >
            {processSection.items.map((step, index) => {
              const Icon = step.icon
              return (
                <Box
                  key={step.title.en}
                  component={motion.div}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.3 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  sx={{
                    position: 'relative',
                    borderRadius: '18px',
                    border: '1px solid rgba(217,214,207,0.12)',
                    bgcolor: 'rgba(217,214,207,0.03)',
                    p: 3.5,
                    transition: 'border-color 0.3s ease',
                    '&:hover': { borderColor: 'rgba(122,46,58,0.5)' },
                  }}
                >
                  <Typography
                    sx={{
                      position: 'absolute',
                      top: 14,
                      insetInlineEnd: 18,
                      fontFamily: headingFont,
                      fontWeight: 700,
                      fontSize: '1.4rem',
                      color: 'rgba(217,214,207,0.12)',
                    }}
                  >
                    {String(index + 1).padStart(2, '0')}
                  </Typography>
                  <Box
                    sx={{
                      width: 52,
                      height: 52,
                      borderRadius: '14px',
                      bgcolor: 'rgba(122,46,58,0.15)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 2.5,
                    }}
                  >
                    <Icon sx={{ color: '#7A2E3A', fontSize: 26 }} />
                  </Box>
                  <Typography
                    sx={{
                      fontFamily: headingFont,
                      fontWeight: 600,
                      fontSize: '1.1rem',
                      color: '#D9D6CF',
                      mb: 1.2,
                    }}
                  >
                    {step.title[lang]}
                  </Typography>
                  <Typography sx={{ fontFamily: bodyFont, color: 'rgba(217,214,207,0.65)', fontSize: '0.9rem', lineHeight: 1.8 }}>
                    {step.desc[lang]}
                  </Typography>
                </Box>
              )
            })}
          </Box>
        </Box>
      </Box>

    </Box>
  )
}